import { enableProdMode, provideZoneChangeDetection } from '@angular/core';

import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import '@angular/compiler';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { AppComponent } from './app/app.component';
import { APP_ROUTES } from './app/app.routes';
import { authErrorInterceptor } from './app/interceptors/auth-error.interceptor';
import { refererInterceptor } from './app/interceptors/referer.interceptor';
import { usernameValidationInterceptor } from './app/interceptors/username-validation.interceptor';
import { TranslationLoaderService } from './app/services/translation-loader.service';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

(function () {
  const originalSetItem = localStorage.setItem;
  localStorage.setItem = function (key: string, value: string) {
    const event = new Event('localStorageChanged');
    (event as any).key = key;
    (event as any).newValue = value;
    window.dispatchEvent(event);
    return originalSetItem.apply(this, arguments as any);
  };
})();

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useClass: TranslationLoaderService,
      },
      isolate: true,
    }),
    provideRouter(APP_ROUTES),
    provideHttpClient(withInterceptors([usernameValidationInterceptor, authErrorInterceptor, refererInterceptor]), withInterceptorsFromDi()),
    ...provideAnimations(),
    provideOAuthClient(),
  ],
}).catch((err) => console.error(err));
